import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Module } from 'src/app/core/model/tenants/module.model';
import { ApiClientService } from 'src/app/core/services/api-client.service';

@Component({
    selector: 'app-module-list',
    templateUrl: './module-list.component.html',
    styleUrls: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModuleListComponent implements OnInit {
  tenantCode: string;
  activeModules: Module[];
  availableModules: Module[];
  actionsEnabled=true;

  constructor(private api: ApiClientService,
    private route: ActivatedRoute,
    private router: Router) { }

  ngOnInit(): void {
    this.tenantCode = this.route.snapshot.params['tenantCode'];
    this.refresh();
  }

  refresh(): void {
    this.api.getActiveModules(this.tenantCode).subscribe(modules => this.activeModules = modules);
    this.api.getAvailableModules(this.tenantCode).subscribe(modules => this.availableModules = modules);
  }

  onActivateModule(module: Module) {
    this.api.activateModule(this.tenantCode, module).subscribe(() => this.refresh());
  }
}
